import {
  Config,
  IFinalResponse,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '../Core';

export const API_DOMAIN: EndPointsNames = 'ApiUpload';
export const ENDPOINT_API_PATH = 'file-upload';

export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_X_API_KEY';
export const URL_POSTMAN = '#';
export const CODE_ERRORS: ErrorResponseCodeType<null>[] = [
  {
    code: '1',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
    bussinessErrorVariant: 'errorService',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

const callPost = async (params: {
  category: string;
  extension: string;
  file: string;
}): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...params,
    },
  };
  return Config.API.post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { post: callPost };
export default { call, definitions };
